/**
 * Shared hook for From / CC / BCC options across scheduling steps.
 * Prepends the "Organizer email" sentinel to the delegatable user list.
 */
import { useMemo } from 'react';
import type { SelectOption } from '@kula-ai/components';
import { useInterviewCommunicationSenderOptions } from '../../InterviewActivity/communication/api';
import { INTERVIEW_EMAIL_SENDER_ORGANIZER_VALUE } from '../../InterviewActivity/communication/communication.types';
import { SCHEDULE_INTERVIEW_COPY } from '../schedule.copy';

export function useScheduleSenderOptions() {
  const { data: delegatableRaw = [] } =
    useInterviewCommunicationSenderOptions();

  const fromOptions = useMemo(() => {
    const copy = SCHEDULE_INTERVIEW_COPY.communication.organizerSender;
    const organizer: SelectOption = {
      value: INTERVIEW_EMAIL_SENDER_ORGANIZER_VALUE,
      label: copy.label,
      description: copy.description,
    };
    const rest = delegatableRaw.filter(
      (o) => o.value !== INTERVIEW_EMAIL_SENDER_ORGANIZER_VALUE
    );
    return [organizer, ...rest];
  }, [delegatableRaw]);

  return { fromOptions, ccBccOptions: fromOptions };
}
